import { useModals } from "@/modules/providers/ModalProvider";

export function Modals() {
  const { stack } = useModals();
  return (
    <>
      {stack.map((modal, index) => (
        <modal.component
          key={`modal-${modal.id}-${index}`}
          data={modal.data}
          close={(v) => modal.close(v)}
          isOpen={modal.isOpen}
          id={modal.id}
          index={index}
        />
      ))}
    </>
  );
}
